module.exports = __webpack_public_path__ + "5e14e350f03dde04ef3f7671948d627c.svg";